import React from 'react';
import './DirectvProvider.css';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import logo1 from "../../Includes/Images/Group-10.png";
import provider1 from "../../Includes/Images/Group-1000004731.png";
import WideCoverage from './WideCoverage';

const DirectvProvider = () => {
  return (
    <>
      <Header/>
      <div className="direcContainer">
        {/* Header Section */}
        <div className="direcHeader">
          <div className="direcLogo">
            <img src={logo1} alt="DIRECTV Preferred Dealer" className="direcDealerLogo"/>
          </div>
        </div>

        {/* Hero Section */}
        <div className="direcHero">
          <div className="direcHeroContent">
            <div className="direcHeroTextContent">
              <h1 className="direcHeroTitle">
                Get <span className="direcBlue">DIRECTV</span> Your Way - Over the Internet or With a Satellite Dish
              </h1>
              <p className="direcHeroDescription">
                Tailor Your TV Experience Your Way With DIRECTV. Enjoy Non-Stop Entertainment On Cable And All Major Streaming Platforms. 
                Record Your Favorite Shows With Unlimited DVR Storage To Watch Later.
              </p>
              <div className="direcCta">
                <a href="tel:+18442172287" className="direcCtaButton">
                  <span className="direcPhoneIcon">📞</span> Call +1-888-348-6689
                </a>
              </div>
            </div>
            <div className="direcPriceTagWrapper">
              <div className="direcPriceTag">
                <p className="direcStartingPrice">
                  Starting at
                  <span className="direcPrice">$69.99</span>
                  <span className="direcPricePeriod">/mo</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* About Us Section */}
        <div className="direcSection direcAbout">
          <div className="direcAboutContainer">
            <div className="direcAboutLeft">
              <h2 className="direcSectionTitle">About Us</h2>
            </div>
            <div className="direcAboutRight">
              <p className="direcAboutText">
                DIRECTV Offers You A Seamless Solution For All Your Entertainment Needs. With Cloud DVR Recording, You Can 
                Enjoy Your Favorite TV Shows At Your Convenience.
              </p>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="direcSection direcFeatures">
          <div className="direcFeatureCards">
            <div className="direcFeatureCard">
              <img 
                src={provider1} 
                alt="Woman with smartphone" 
                className="direcFeatureImage" 
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Plans Section */}
        <div className="direcSection direcPlans">
          <h2 className="direcSectionTitle direcPlansTitle">Shop DIRECTV Plans</h2>
          <div className="direcPlanCards">
            {/* Entertainment Plan */}
            <div className="direcPlanCard">
              <div className="direcPlanHeader">
                <h3 className="direcPlanType">Entertainment</h3>
              </div>
              <div className="direcPlanPrice">
                <h2 className="direcPlanCost">$69.99 <span className="direcPlanPeriod">/mo</span></h2>
                <p className="direcPlanTerms">for 24 months plus taxes and fees</p>
              </div>
              <div className="direcPlanFeatures">
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>Unlimited Cloud DVR</p>
                </div>
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>First Genie Receiver box included</p>
                </div>
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>60,000+ on-demand movies and shows</p>
                </div>
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>First 3 months of Max, Paramount+ with SHOWTIME, STARZ, MGM+™ and Cinema+™ included*</p>
                </div>
              </div>
              <div className="direcPlanAction">
                <a href="tel:+18442172287" className="direcCtaButton">
                  <span className="direcPhoneIcon">📞</span> Call Now
                </a>
              </div>
            </div>

            {/* Choice Plan - Featured */}
            <div className="direcPlanCard direcFeaturedPlan">
              <div className="direcFeaturedTag">Most Popular</div>
              <div className="direcPlanHeader">
                <h3 className="direcPlanType">Choice</h3>
              </div>
              <div className="direcPlanPrice">
                <h2 className="direcPlanCost">$89.99 <span className="direcPlanPeriod">/mo</span></h2>
                <p className="direcPlanTerms">for 24 months plus taxes and fees</p>
              </div>
              <div className="direcPlanFeatures">
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>Specialty sports channels like NBA TV, ACC Network, and more</p>
                </div>
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>Regional sports networks</p>
                </div>
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>70,000+ on-demand movies and shows</p>
                </div>
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>First 3 months of Max, Paramount+ with SHOWTIME, STARZ, MGM+™ and Cinema+™ included</p>
                </div>
              </div>
              <div className="direcPlanAction">
                <a href="tel:+18442172287" className="direcCtaButton">
                  <span className="direcPhoneIcon">📞</span> Call Now
                </a>
              </div>
            </div>

            {/* Ultimate Plan */}
            <div className="direcPlanCard">
              <div className="direcPlanHeader">
                <h3 className="direcPlanType">Ultimate</h3>
              </div>
              <div className="direcPlanPrice">
                <h2 className="direcPlanCost">$114.99 <span className="direcPlanPeriod">/mo</span></h2>
                <p className="direcPlanTerms">for 24 months plus taxes and fees</p>
              </div>
              <div className="direcPlanFeatures">
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>Premium sports and movie channels including CBS Sports Network, NFL Network, FX Movies, Starz Encore, and more</p>
                </div>
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>80,000+ on-demand movies and shows</p>
                </div>
                <div className="direcPlanFeature">
                  <span className="direcCheckmark">✓</span>
                  <p>First 3 months of Max, Paramount+ with SHOWTIME, STARZ, MGM+™ and Cinema+™ included</p>
                </div>
              </div>
              <div className="direcPlanAction">
                <a href="tel:+18442172287" className="direcCtaButton">
                  <span className="direcPhoneIcon">📞</span> Call Now
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Free Installation Section */}
        <div className="direcSection direcInstallation">
          <div className="direcInstallationContainer">
            <div className="direcInstallationLeft">
              {/* <img 
                src={installImage} 
                alt="Professional installation" 
                className="direcInstallationImage" 
                loading="lazy"
              /> */}
            </div>
            <div className="direcInstallationRight">
              <h2 className="direcInstallationTitle">
                DIRECTV Offers Free Of Cost Satellite Dish Installation By Professional Technicians.
              </h2>
              <p className="direcInstallationText">
                Enjoy TV With Your Home Internet Through Gemini™, Offering Access To Thousands Of Streaming Apps, Like Netflix, Amazon Hulu, Etc. Gemini Comes With It's Own Google Assisted Voice-Controlled Remote™.
              </p>
              <div className="direcInstallationAction">
                <a href="tel:+18442172287" className="direcCtaButton">
                  <span className="direcPhoneIcon">📞</span> Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <WideCoverage/>
      <Footer/>
    </>
  );
};

export default DirectvProvider;